export default class OfferStocklist {
  constructor($scope, $rootScope, OfferService) {
    function get_offer_date_options() {
      var options = [];
      options.push({
        id: 0,
        title: 'Updated (' + window.offer.updated_at.substring(0, 10) + ')'
      });
      if (window.offer.published_at)
        options.push({
          id: 1,
          title: 'Published (' + window.offer.published_at.substring(0, 10) + ')'
        });
      return options;
    }

    $scope.update_supplier_pricings = function() {
      $scope.updating_supplier_pricings = true;
      OfferService.update_supplier_pricings(window.offer.id, $scope.offer_date_mode).success(function(data) {
        if (data.success)
          $scope.updating_supplier_pricings = false;
      });
    };

    $scope.update_offer_version = function() {
      $scope.updating_offer_version = true;
      OfferService.update_offer_version(window.offer.id).success(function(data) {
        if (data.success) {
          $scope.offer_version = data.offer_version;
          $scope.updating_offer_version = false;
        }
      });
    };

    $scope.create_campaign = function(send) {
      var data = {
        offer_id: $scope.offer.id,
        campaign_settings: $scope.offer.offer_campaign_settings,
        total_count: 1,
        current_index: 0,
        send: send
      };
      $rootScope.$broadcast('show_create_campaign', data);
    };

    $scope.init = function() {
      $scope.offer = window.offer;
      $scope.offer_date_mode = 0;
      $scope.offer_date_options = get_offer_date_options();
      $scope.offer_version = window.offer_version;
    };

    $scope.init();
  }
}

OfferStocklist.$inject = ['$scope', '$rootScope', 'OfferService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-stocklist.ctrl.js